import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle.ts";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import i18n from "i18next";
import { PdfView } from "./PdfView";
import { ThreeJsView } from "./ThreeJsView";
import { ImageView } from "./ImageView";
import { Box } from "@mui/material";

export interface FilePreviewViewProps {
	fileHandle: FrontendDownloadFileHandle;
}

export const FilePreviewView = (
	{
		fileHandle
	}: FilePreviewViewProps) => {
	const extension = fileHandle.fileExtension.toLowerCase();

	if (extension === "pdf")
		return <PdfView fileHandle={fileHandle} />;

	if (extension === "ifc")
		return <ThreeJsView fileHandle={fileHandle} />;

	if (["jpg", "jpeg", "png", "gif", "svg", "ico"].includes(extension))
		return <ImageView fileHandle={fileHandle} />;

	if (["txt", "btl", "wup", "asc"].includes(extension))
		return <TextView fileHandle={fileHandle} />;

	if (["mp4", "webm", "ogg", "mp3", "wav"].includes(extension))
		return <VideoView fileHandle={fileHandle} />;

	return <CenteredTypography>
		{i18n.t("cannot_render_file_with_extension", { extension })}
	</CenteredTypography>;
};


const VideoView = ({ fileHandle }: FilePreviewViewProps) => {
	return <Box
		sx={{
			flex: 1,
			display: "flex",
			"& video": {
				flex: 1
			}
		}}>
		<video controls={true}>
			<source src={fileHandle.fileUrl} />
		</video>
	</Box>;
};

const TextView = ({ fileHandle }: FilePreviewViewProps) => {
	return <object data={fileHandle.fileUrl} style={{
		flex: 1,
	}}/>;
};
